import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { Auth } from './types'
import { RootState } from '../types'

export const state: Auth = {
  connection: null,
  status: '',
  token: localStorage.getItem('ACCESS_TOKEN') || '',
  user: JSON.parse(String(localStorage.getItem('user'))),
  tokenValid: false,
  wsConnectionActive: false,
  session: {}
}

const namespaced = true

export const auth: Module<Auth, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
